/** Non-drop-frame timecode for the Studio's fixed 30 fps timeline. */
export function frameTimecode(frame: number): string {
  const seconds = Math.floor(frame / 30);
  return [Math.floor(seconds / 3600), Math.floor(seconds / 60) % 60, seconds % 60, frame % 30]
    .map(value => String(value).padStart(2, '0')).join(':');
}

export function parseFrameTimecode(value: string): number | null {
  if (!/^\d{2}:\d{2}:\d{2}:\d{2}$/.test(value)) return null;
  const [hours, minutes, seconds, frames] = value.split(':').map(Number) as [number, number, number, number];
  if (minutes >= 60 || seconds >= 60 || frames >= 30) return null;
  return ((hours * 60 + minutes) * 60 + seconds) * 30 + frames;
}
